import moment from "moment";
import { useTranslation } from "react-i18next";
import useAuth from "src/hooks/selectors/useAuth";
import useVariant, { VariantTypes } from "src/hooks/useVariant";

interface ConnectDiscountBannerProps {
	variant: VariantTypes;
	type: "default" | "countdown";
}

const ConnectDiscountBanner = ({
	variant,
	type,
}: ConnectDiscountBannerProps) => {
	const { t } = useTranslation("promotion", {
		keyPrefix: "connect-discount-banner",
	});
	const _variant = useVariant(variant);
	const auth = useAuth();
	const { promos, promos_expires } = auth.company;

	if (!promos?.includes("connect_discount")) {
		return <></>;
	}

	const days = moment(promos_expires["connect_discount"]).diff(
		moment(),
		"days"
	);

	if (type === "countdown") {
		return (
			<div
				className={`${_variant} px-8 py-4 flex flex-col justify-center items-center rounded-md mb-8`}
			>
				{days <= 0 ? (
					<strong>{t("last-day")}</strong>
				) : (
					<strong>
						{t("days-remaining", {
							days,
						})}
					</strong>
				)}
			</div>
		);
	}

	return (
		<div
			className={`${_variant} px-8 py-4 flex justify-center items-center flex-col rounded-md mb-8`}
		>
			<strong className="text-center">{t("title")}</strong>
			<p className="text-center mt-2">
				{t("description", {
					date: moment(promos_expires["connect_discount"]).format(
						"DD-MM-YYYY"
					),
				})}
			</p>
		</div>
	);
};

ConnectDiscountBanner.defaultProps = {
	type: "default",
	variant: "primary",
};

export default ConnectDiscountBanner;
